<template>
  <tr>
    <td colspan="5">
      <b>{{ index }}. {{ name }}</b>
    </td>
  </tr>
  <template v-for="configuration in configurations" :key="configuration.id">
    <print-job-article-configuration
      :configuration="configuration"
      :article="article"
      @show="show">
    </print-job-article-configuration>
  </template>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'

const store = useMainStore()
// define props
const props = defineProps({
  index: {
    type: Number,
    required: true,
  },
  article: {
    type: Object,
    required: true
  },
  printJobConfigurations: {
    type: Array,
    required: true
  }
})
// define emits
const emit = defineEmits(['show'])
// define computed properties
const locale = computed(() => store.settings.locale)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const baseArticle = computed(() => {
  return props.article.article
})

const name = computed(() => {
  return (inEnglish.value) ? baseArticle.value.name_en : baseArticle.value.name
})

const configurations = computed(() => {
  const configurationsIds = props.printJobConfigurations
    .map((configuration) => configuration.request_article_configuration_id)

  return props.article.prints
    .map((item) => item.configurations)
    .flat()
    .filter((configuration) => {
      return (
        configuration.group === props.index
        && configurationsIds.includes(configuration.id)
      )
    })
})
// define methods
const show = (article) => {
  emit('show', article)
}
</script>